class Finder {
  findRecursive(property, value, items) {
    for (const item of items) {
      if (item[property] === value) {
        return item;
      }
      if (item.children.length > 0) {
        const child = this.findRecursive(property, value, item.children);
        if (child) {
          return child;
        }
      }
    }
  }
}
const finder = new Finder();
export { finder };